import store from '../store';
import * as actions from "./serviceCallTypes";
import { handleAxiosPost, handleAxiosGet } from '../axiosHelper';

export const getServiceCallList = async (paramValues) => {
    const url = '/ServiceCall/GetServiceCallList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_SERVICE_CALL_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getServiceCallCount = async (paramValues) => {
    const url = '/ServiceCall/GetServiceCallCount';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const getEquipmentSearch = async (paramValues) => {
    const url = '/ServiceCall/EquipmentSearch';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_EQUIPMENT_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getProblemList = async (paramValues) => {
    const url = '/ServiceCall/GetProblemList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_PROBLEM_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const GetSubProblemList = async (paramValues) => {
    const url = '/ServiceCall/GetSubProblemList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_SUB_PROBLEM_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const saveServiceCall = async (payload) => {
    const url = '/ServiceCall/SaveServiceCall';
    const contentType = "multipart/form-data";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const exportServiceCall = async (item) => {
    let url = '/ServiceCall/ExportServiceCall';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        return responseData;
    } else {
        return responseData;
    }
};